var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-placeholder"},[_c('img',{attrs:{"id":"preview-image","src":_vm.previewAsset,"alt":"Preview Asset"}}),_c('h1',[_vm._v("The preview is loading")]),_c('h2',[_vm._v("Some assets can take some time to load")]),_c('img',{attrs:{"alt":"spinner","src":_vm.spinnerImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }